import { Config } from '@models/config';
import { set } from 'radashi';

declare global {
  interface Window {
    env: '${INJECT_ENV}' | Record<string, string>;
    config: Config;
  }
  const config: Config;
}

const envPrefix = 'UI_';
const env = {};
const paramPrefix = 'config_override_';
const params = new URLSearchParams(window.location.search);
let config = {};

Object.assign(env, import.meta.env);

if (window.env !== '${INJECT_ENV}') {
  Object.assign(env, window.env);
}

for (const [key, value] of Object.entries(env)) {
  if (key.startsWith(envPrefix)) {
    config = set(config, key.slice(envPrefix.length), value);
  }
}

for (const [key, value] of params) {
  if (key.startsWith(paramPrefix)) {
    config = set(config, key.slice(paramPrefix.length), value);
  }
}

window.config = Config.parse(config);
